<div
  class="photos"
  [ngStyle]="{
    cursor: currentCursor,
  }"
>
  <lib-checkbox [formControl]="showOnlyPhotosWithMatchingConfig$"
    >Pokaż tylko przypisane zdjęcia
  </lib-checkbox>
  <lib-checkbox [formControl]="showFileNames">Pokaż nazwy plików </lib-checkbox>
  <lib-checkbox [formControl]="showAllPhotosForCurrentMember"
    >Pokaż wszystkie zdjęcia
  </lib-checkbox>
  @if ((photosToShow$ | async)?.length) {
    <lib-virtual-scroll
      [barOverContent]="true"
      [gridItemSize]="300"
      [hasSort]="false"
      [inlineWidthOnRender]="false"
      [isFull]="false"
      [itemTpl]="photo"
      [photos]="photosToShow$ | async"
      itemIndex="photoInGroupId"
      type="grid"
    >
    </lib-virtual-scroll>
  }
  <ng-template #photo let-index let-photo>
    <div
      class="photoElement"
      [ngClass]="{
        picked:
          photo.photo.photo.photoId
          | isPhotoTaken: (currentConfig$ | async) : (tabloMembers$ | async),
      }"
    >
      <lib-image-loader
        (dragstart)="onDragStart($event, photo)"
        (dragend)="dndInProgress$.next(false)"
        draggable="true"
        (click)="photoClick(photo.photo)"
        [disableLoader]="true"
        [url]="
          {
            photoId: photo.photo.photo.photoId,
          }
            | getImageUrl
              : photo.photo.groupId
              : 'photographer'
              : imagesContext
              : contextId
              : 600
            | async
        "
      ></lib-image-loader>
      @if (showFileNames.value) {
        <div class="fileName">
          {{ photo.photo.photo.originalName }}
        </div>
      }
      <div class="photoLabels">
        @if (photo.photo.assignedLabel) {
          <div class="photoAssignedNames">
            {{ photo.photo.assignedLabel }}
          </div>
        }
        @if (
          photo.photo.photo.photoId
            | isPhotoTaken: (currentConfig$ | async) : (tabloMembers$ | async)
        ) {
          <div class="photoName">
            {{
              photo.photo.photo.photoId
                | memberNameForPickedPhoto
                  : (currentConfig$ | async)
                  : (tabloMembers$ | async)
            }}
          </div>
        }
      </div>
    </div>
  </ng-template>
</div>
<div class="photo">
  <div
    class="photoContainer"
    (drag)="onDrag($event)"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  >
    <div
      class="placeholder"
      [ngClass]="{
        dnd: dndInProgress$ | async,
      }"
    >
      <lib-tablo-face-cropper
        [selectedPoint]="hasFocalPoint$ | async"
        [x]="$safeNavigationMigration((currentFocalPoint | async)?.x)"
        [y]="$safeNavigationMigration((currentFocalPoint | async)?.y)"
        [scale]="scaleFactor.value"
        (updatedEmitter)="pointUpdatedByHand($event)"
        (scaleChanged)="scaleFactor.setValue($event)"
        [imageSize]="currentPhotoSize"
        [url]="
          {
            photoId: $safeNavigationMigration(
              (pickedPhotoId$ | async)?.photoId
            ),
          }
            | getImageUrl
              : $safeNavigationMigration((pickedPhotoId$ | async)?.groupId)
              : 'photographer'
              : imagesContext
              : contextId
              : 600
            | async
        "
      ></lib-tablo-face-cropper>
      @if (faceDetectionInProgress$ | async) {
        <mat-progress-spinner
          [diameter]="150"
          mode="indeterminate"
        ></mat-progress-spinner>
      }
    </div>
  </div>
  @if (
    currentMemberId$
      | async
      | isTabloMemberPickCompleted: (currentConfig$ | async)
  ) {
    <lib-button (click)="removePhoto()">Przypisz innego ucznia </lib-button>
  }

  <div class="previews">
    <div class="preview" style="width: 200px; height: 200px">
      <lib-cover
        [imageSize]="currentPhotoSize"
        [point]="currentFocalPoint | async"
        [style.transform]="'scale(' + scaleFactor.value + ')'"
        [scale]="scaleFactor.value"
        [rotation]="rotation.value"
        [url]="
          {
            photoId: $safeNavigationMigration(
              (pickedPhotoId$ | async)?.photoId
            ),
          }
            | getImageUrl
              : $safeNavigationMigration((pickedPhotoId$ | async)?.groupId)
              : 'photographer'
              : imagesContext
              : contextId
              : 600
            | async
        "
      ></lib-cover>
    </div>
    <div class="preview" style="height: 200px; aspect-ratio: 2/3">
      <lib-cover
        [imageSize]="currentPhotoSize"
        [point]="currentFocalPoint | async"
        [style.transform]="'scale(' + scaleFactor.value + ')'"
        [scale]="scaleFactor.value"
        [rotation]="rotation.value"
        [url]="
          {
            photoId: $safeNavigationMigration(
              (pickedPhotoId$ | async)?.photoId
            ),
          }
            | getImageUrl
              : $safeNavigationMigration((pickedPhotoId$ | async)?.groupId)
              : 'photographer'
              : imagesContext
              : contextId
              : 600
            | async
        "
      ></lib-cover>
    </div>
    <div class="preview" style="height: 200px; aspect-ratio: 3/2">
      <lib-cover
        [imageSize]="currentPhotoSize"
        [point]="currentFocalPoint | async"
        [style.transform]="'scale(' + scaleFactor.value + ')'"
        [scale]="scaleFactor.value"
        [rotation]="rotation.value"
        [url]="
          {
            photoId: $safeNavigationMigration(
              (pickedPhotoId$ | async)?.photoId
            ),
          }
            | getImageUrl
              : $safeNavigationMigration((pickedPhotoId$ | async)?.groupId)
              : 'photographer'
              : imagesContext
              : contextId
              : 600
            | async
        "
      ></lib-cover>
    </div>
  </div>
  <input type="range" [formControl]="scaleFactor" min="1" max="3" step="0.01" />
  <div class="rotationContainer">
    <input
      type="range"
      [formControl]="rotation"
      min="-180"
      max="180"
      step="1"
    />
    <lib-button icon-only (click)="rotation.setValue(0)">
      <mat-icon> refresh </mat-icon>
    </lib-button>
  </div>
  <lib-button lg (click)="saveCurrent()">Zapisz osobę (lub spacja)</lib-button>
</div>
<div class="members">
  @if (hasShootSequencePanel) {
    <div class="membersHeader">
      <lib-button
        (click)="toggleShootSequencePanel()"
        [disabled]="shootSequenceLoading$ | async"
      >
        {{
          showShootSequencePanel
            ? 'Ukryj kolejność wykonania'
            : 'Pokaż kolejność wykonania'
        }}
      </lib-button>
    </div>
  }
  <div class="list">
    @for (member of tabloMembers$ | async; track member) {
      <div
        class="member"
        (click)="showMember(member.tabloMemberId, true)"
        [ngClass]="{
          active:
            member.tabloMemberId === (currentMember$ | async)?.tabloMemberId,
          isCompleted:
            member.tabloMemberId
            | isTabloMemberPickCompleted: (currentConfig$ | async),
        }"
      >
        {{ member.firstName }} {{ member.lastName }}
      </div>
    }
  </div>
  <lib-progress-bar [progress]="completionProgress$ | async"></lib-progress-bar>

  <lib-button (click)="complete()">Zakończ</lib-button>
</div>
@if (showShootSequencePanel && hasShootSequencePanel) {
  <div class="shootSequencePanel">
    <div class="shootSequenceHeader">
      <h3>Kolejność wykonania</h3>
      <p>Na podstawie odhaczania zdjęć w zakładce sesji.</p>
    </div>
    @if (hasShootSequencePackageFilter) {
      <mat-form-field libZalamoField>
        <mat-label>Pakiet</mat-label>
        <mat-select [formControl]="shootSequencePackageControl">
          @for (option of shootSequencePackageOptions$ | async; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
    }
    @if (shootSequenceLoading$ | async) {
      <div class="shootSequenceState">Ładowanie kolejności...</div>
    }
    @if (shootSequenceError$ | async; as error) {
      <div class="shootSequenceState error">
        {{ error }}
      </div>
    }
    @if (
      !(shootSequenceLoading$ | async) &&
      !(shootSequenceError$ | async) &&
      !(visibleShootSequenceEntries$ | async)?.length
    ) {
      <div class="shootSequenceState">
        Brak zapisanej kolejności dla bieżącego filtra.
      </div>
    }
    @if (
      !(shootSequenceLoading$ | async) &&
      !(shootSequenceError$ | async) &&
      (visibleShootSequenceEntries$ | async)?.length
    ) {
      <div class="shootSequenceList">
        @for (
          entry of visibleShootSequenceEntries$ | async;
          track entry;
          let i = $index
        ) {
          <div class="shootSequenceRow">
            <div class="shootSequenceOrder">{{ i + 1 }}</div>
            <div class="shootSequenceDetails">
              <strong>{{ entry.childName }}</strong>
              @if (entry.packageLabel) {
                <span>{{ entry.packageLabel }}</span>
              }
            </div>
            <div class="shootSequenceTime">{{ entry.clickedAtLabel }}</div>
          </div>
        }
      </div>
    }
  </div>
}
